var _style, _path, _path2, _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgChina = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.ch_st0{fill:#DE2910;}\n\t.ch_st1{fill:#57A863;}\n\t.ch_st2{fill:#FFDE00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy",
    className: "ch_st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "ch_st1",
    d: "M64,5.3v31.4c0-0.1,0-0.3,0-0.4V5.7C64,5.6,64,5.5,64,5.3z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "ch_st2",
    points: "11.3,5.2 12.5,8.6 16.1,8.6 13.1,10.8 14.3,14.2 11.3,12.1 8.4,14.2 9.5,10.8 6.6,8.6 10.2,8.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "ch_st2",
    points: "19.4,1.9 19.6,3.2 20.9,3.5 19.7,4 19.8,5.4 18.9,4.4 17.7,5 18.3,3.8 17.4,2.8 18.7,3.1 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "ch_st2",
    points: "22.3,6.2 23,7.3 24.3,7.1 23.4,8.1 24.1,9.2 22.9,8.7 22,9.7 22.1,8.3 20.9,7.8 22.2,7.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "ch_st2",
    points: "21.9,11 22.3,12.3 23.6,12.3 22.5,13.1 22.9,14.4 21.9,13.6 20.8,14.4 21.2,13.1 20.2,12.2 21.5,12.3  "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "ch_st2",
    points: "19.3,14.8 19.1,16.1 20.4,16.6 19.1,17 19,18.4 18.3,17.2 17,17.6 17.9,16.5 17.2,15.4 18.4,15.8 "
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChina, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/China.b29bfdf3.svg";
export { ForwardRef as ReactComponent };